export class ValidationException extends Error {
  constructor(message) {
    super(message);
    this.message = message;
    this.name = 'ValidationException';
  }
}
